module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('order', {
    attrs: {
      "order-id": _vm.$route.params.id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9611fe68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/orders/OrderView.vue
// module id = 574
// module chunks = 0